import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@strava/ui/Button';
import styles from './GmailContactList.scss';

import { t } from '../../../../../../utils/InviteFriends.utils';

const GmailContactList = ({ contacts, disconnect }) => {
  return (
    <>
      <h3 className={styles.headline}>
        {t('modal.email.gmail_authorized.title')}
      </h3>
      <LinkButton href="#" variant="text" onClick={disconnect}>
        {t('modal.email.gmail_authorized.disconnect')}
      </LinkButton>
      {contacts.length ? (
        <p>{JSON.stringify(contacts)}</p>
      ) : (
        <p>No contacts were found</p>
      )}
    </>
  );
};

GmailContactList.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disconnect: PropTypes.func.isRequired
};

export default GmailContactList;
